<template>
  <v-container class="main-container responsive-height mt5-wrapper">
    <v-row dense>
      <v-col cols="12" class="position-relative">
        <AllSignalTabs></AllSignalTabs>
        <div class="buy-sale-list">
          <ul>
            <li class="ml-3"><v-icon color="greenMain" class="mr-1">mdi mdi-circle</v-icon> Buy</li>
            <li class="ml-5"><v-icon color="#FF567F" class="mr-1">mdi mdi-circle</v-icon> Sale</li>
          </ul>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import AllSignalTabs from '@/components/PagesComponents/AllSignals/AllSignalTabs';

export default {
  components: {
    
    AllSignalTabs,
  },
};
</script>
